<template>
  <el-dialog
    top="80px"
    width="600px"
    class="package-form"
    :title="!placeFacilityGroup ? 'Thêm mới nhóm tiện ích' : 'Chỉnh sửa nhóm tiện ích'"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-position="top" :rules="rules">
      <el-form-item label="Tên nhóm tiện ích" prop="name">
        <el-input v-model="form.name" placeholder="Nhập vào tên nhóm tiện ích"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="callingAPI" @click="handleClose">Hủy</el-button>
      <el-button type="primary" :loading="callingAPI" @click="handleUpdate">
        {{ !placeFacilityGroup ? 'Tạo' : 'Cập nhật' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { createPlaceFacilityGroup, updatePlaceFacilityGroup } from '@/services/place/facility-group'

export default {
  name: 'UpdatePlaceFacilityGroup',
  props: {
    placeFacilityGroup: Object,
    visible: Boolean
  },
  data() {
    return {
      callingAPI: false,
      form: {
        name: this.placeFacilityGroup ? this.placeFacilityGroup.name : ''
      },
      rules: {
        name: [
          { required: true, message: 'Tên nhóm tiện ích không được để trống', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['language']),
    dataInput() {
      const data = {
        name: this.form.name,
        locale: this.language
      }
      if (this.placeFacilityGroup) {
        data.id = this.placeFacilityGroup.id
      }
      return data
    }
  },
  methods: {
    handleUpdate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true
          if (!this.placeFacilityGroup) {
            createPlaceFacilityGroup(this.dataInput).then(() => {
              this.$notify.success({
                title: 'Thành công',
                message: 'Tạo mới nhóm tiện ích thành công'
              })
              this.$emit('reload')
              this.$emit('reload-constant')
              this.callingAPI = false
            }).catch(() => {
              this.callingAPI = false
            })
          } else {
            updatePlaceFacilityGroup(this.dataInput).then(() => {
              this.$notify.success({
                title: 'Thành công',
                message: 'Cập nhật nhóm tiện ích thành công'
              })
              this.$emit('reload')
              this.$emit('reload-constant')
              this.callingAPI = false
            }).catch(() => {
              this.callingAPI = false
            })
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
